// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__vbypw","topBottomGutter":"Layout_topBottomGutter__3Ea6i"};